import Dexie from "dexie";

interface StemscopesDb extends Dexie {
  user?: any;
  deferred?: any;
  requestResources?: any;
}

const db: StemscopesDb = new Dexie("stemscopes");
db.version(3).stores({
  user: "id, data, pin",
  deferred: "id, userId, data, method, config",
  requestResources: "id, userId, title, list, saved, autoSave",
});

export default db;
